import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { ColumnConfig } from '@/components/table/Table';
import { GlobalButton } from '@/components';
import { 
  Person as PersonIcon,
} from '@mui/icons-material';
import { appUrl } from '@/utils/appUrl';

interface ColumnHelpers {
  formatDate: (date: string | null | undefined) => string;
  formatDuration: (minutes: number | null) => string;
  getStatusColorClass: (minutes: number) => string;
  onViewShippings: (driverId: string, driverName: string) => void;
}

export const getDriversWithOpenReturnsColumns = ({
  formatDate,
  formatDuration,
  getStatusColorClass,
  onViewShippings,
}: ColumnHelpers): ColumnConfig[] => [
  {
    label: 'Conductor',
    field: 'driverName',
    render: (value, item) => (
      <div 
        className='flex items-center gap-3 py-1.5 group cursor-pointer'
        onClick={() => {
          window.open(appUrl(`/business/drivers/${item.driverId}`), '_blank');
        }}
      >
        <div className='w-10 h-10 rounded-full bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors border border-orange-100/50'>
          <PersonIcon className='text-[#ff7500] pb-0.5' sx={{ fontSize: 20 }} />
        </div>
        <span className='font-bold text-[#ff7500] text-[16px] truncate group-hover:underline transition-colors'>
          {value}
        </span>
      </div>
    ),
  },
  {
    label: 'Deuda desde',
    field: 'oldestOpenAt',
    sortable: true,
    render: (value) => {
      const formatted = formatDate(value);
      if (formatted === '-') return <span className='text-gray-400'>-</span>;
      const [date, time] = formatted.split(' ');
      return (
        <div className='flex flex-col leading-tight text-gray-800'>
          <span className='text-[14px] font-bold'>{date}</span>
          <span className='text-[12px] font-medium text-gray-500'>{time}</span>
        </div>
      );
    },
  },
  {
    label: 'Tiempo transcurrido',
    field: 'minutesSinceOldestOpen',
    render: (minutes: number) => {
      const statusColorClass = getStatusColorClass(minutes);
      return (
        <div className='flex justify-start px-2'>
          <div className={`text-[13px] tracking-tight shadow-sm min-w-[80px] text-center ${statusColorClass}`}>
            {formatDuration(minutes)}
          </div>
        </div>
      );
    },
  },
  {
    label: 'Detalles',
    field: 'driverId',
    render: (driverId, row) => (
      <div className='flex justify-start'>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          size='small'
          action={() => onViewShippings(driverId, row.driverName)}
        >
          <span className='text-[11px] font-bold px-1 uppercase tracking-wider'>
            Ver pedidos
          </span>
        </GlobalButton>
      </div>
    ),
  },
];
